export {
  EMAIL_REGEX,
  FULL_NAME_ERROR_MESSAGE,
  INCORRECT_FORMAT_MESSAGE,
  PHONE_REGEX,
  REQUIRED_FIELD_MESSAGE,
} from '@packages/shared-ui/validation';

export const ZIP_REGEX = /^\d{5}$/;
export const MONEY_REGEX = /^\d+$/;

export const OWNS_HOME_ERROR_MESSAGE =
  "We're sorry, but you'll only be able to purchase solar if you own your home.";
export const AUTOCOMPLETE_ERROR = 'Please select an address';
